import { storage } from '../config/firebaseConfig.js';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';

const TYPE_MAP = {
  'image/jpeg': 'IMG',
  'image/jpg': 'IMG',
  'image/png': 'IMG',
  'image/webp': 'IMG',
  'application/pdf': 'PDF',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOC',
};

export const documentService = {
  /**
   * Upload a file to Firebase Storage under the "documents/" folder.
   * Returns { success, fileUrl, fileName } or { success: false, error }.
   */
  async uploadToFirebase(file, onProgress) {
    try {
      const timestamp = Date.now();
      const sanitized = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
      const fileName = `${timestamp}_${sanitized}`;
      const storageRef = ref(storage, `documents/${fileName}`);

      await new Promise((resolve, reject) => {
        const task = uploadBytesResumable(storageRef, file);
        task.on(
          'state_changed',
          (snap) => {
            if (onProgress) {
              const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
              onProgress(pct);
            }
          },
          reject,
          resolve,
        );
      });

      const fileUrl = await getDownloadURL(storageRef);
      return { success: true, fileUrl, fileName };
    } catch (error) {
      console.error('Error uploading document to Firebase:', error);
      return { success: false, error: 'Erro ao enviar arquivo para o servidor' };
    }
  },

  /**
   * Save document metadata to the API.
   */
  async saveDocument({ ownerId, ownerType, petId, title, fileUrl, fileName, fileType, visibleToTutor = true }) {
    try {
      const type = TYPE_MAP[fileType] || 'DOC';
      const payload = { ownerId, ownerType, petId, type, title, fileUrl, fileName, visibleToTutor };
      const response = await api.post(ENDPOINTS.DOCUMENTS, payload);
      return { success: true, document: response.data.response || null };
    } catch (error) {
      console.error('Error saving document:', error);
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao salvar documento' };
    }
  },

  /**
   * Delete a document by id.
   */
  async deleteDocument(documentId) {
    try {
      await api.delete(`${ENDPOINTS.DOCUMENTS}/${documentId}`);
      return { success: true };
    } catch (error) {
      console.error('Error deleting document:', error);
      return { success: false, error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao remover documento' };
    }
  },

  getFileType(file) {
    return TYPE_MAP[file.type] || 'DOC';
  },
};
